<template>
  <div class="container">
    <div class="card-container">
      <div class="card">
        <div class="card-header">
          <h2>Berita Terkini</h2>
        </div>
        <div class="card-body">
          <div
            class="news-slider"
            @mouseenter="pauseSlider"
            @mouseleave="startSlider"
          >
            <div
              class="slider-container"
              :style="{
                transform: `translateX(-${currentSlide * 100}%)`,
                transition: 'transform 1s ease',
              }"
            >
              <div
                class="slide"
                v-for="(slide, index) in groupedNews"
                :key="index"
              >
                <div class="news-item" v-for="news in slide" :key="news.id">
                  <img :src="`https://mui-kendal.or.id/pengurus/assets/files/upload/berita/${news.image}`" alt="" class="news-image" />
                  <div class="news-content">
                    <h3>{{ news.judul }}</h3>
                    <p>{{ news.pubDate }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      newsList: [],
      currentSlide: 0,
      autoplayInterval: null,
      loading: true,
      error: null,
    };
  },
  computed: {
    groupedNews() {
      const chunkSize = 3;
      const chunks = [];
      for (let i = 0; i < this.newsList.length; i += chunkSize) {
        chunks.push(this.newsList.slice(i, i + chunkSize));
      }
      return chunks;
    },
  },
  methods: {
    async fetchNews() {
      try {
        const response = await axios.get("https://mui-kendal.or.id/pengurus/Api/getNews/9");
        this.newsList = response.data.Data;
      } catch (err) {
        this.error = "Gagal memuat berita. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString("id-ID", options);
    },
  
  
    startSlider() {
      if (!this.autoplayInterval) {
        this.autoplayInterval = setInterval(this.nextSlide, 3000);
      }
    },
    pauseSlider() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    },
    nextSlide() {
      if (this.currentSlide < this.groupedNews.length - 1) {
        this.currentSlide++;
      } else {
        this.currentSlide = 0;
      }
    },
  },
  created() {
    this.fetchNews();
  },
  mounted() {
    this.startSlider();
  },
  beforeUnmount() {
    this.pauseSlider();
  },
};
</script>

<style scoped>
.card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh; /* Tengah vertikal */
  background-color: #f9f9f9; /* Warna latar belakang */
}

.card {
  /* width: 90%; */
  /* max-width: 800px; Batas lebar card */
  background: #fff;
  border-radius: 12px;
  border: 0;
  /* box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);  */
  overflow: hidden;
}

.card-header {
  background: white;
  color: black;
  padding-left: 15px;
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  border-bottom: 5px solid #0a7a33;
}

.card-body {
  padding: 15px;
}

.news-slider {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.slider-container {
  display: flex;
}

.slide {
  display: flex;
  flex: 0 0 100%;
  justify-content: space-between;
  gap: 20px;
}

.news-item {
  flex: 1;
  background: #f4f4f4;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
}

.news-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
}

.news-content h3 {
  font-size: 18px;
  margin: 10px 0;
}

.news-content p {
  font-size: 14px;
  color: #888;
}
</style>
